/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: Array<OrganizationsBoolExp> | null | undefined;
  _not?: OrganizationsBoolExp | null | undefined;
  _or?: Array<OrganizationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  kind?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenants?: TenantsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "product_roles". All fields are combined with a logical 'AND'. */
export type ProductRolesBoolExp = {
  _and?: Array<ProductRolesBoolExp> | null | undefined;
  _not?: ProductRolesBoolExp | null | undefined;
  _or?: Array<ProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type ProductsBoolExp = {
  _and?: Array<ProductsBoolExp> | null | undefined;
  _not?: ProductsBoolExp | null | undefined;
  _or?: Array<ProductsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  importDirectWebhookUrl?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  originHosts?: StringComparisonExp | null | undefined;
  productRoles?: ProductRolesBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: Array<RolesBoolExp> | null | undefined;
  _not?: RolesBoolExp | null | undefined;
  _or?: Array<RolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _isNull?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

/** Boolean expression to filter rows from the table "tenant_product_installations". All fields are combined with a logical 'AND'. */
export type TenantProductInstallationsBoolExp = {
  _and?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  _not?: TenantProductInstallationsBoolExp | null | undefined;
  _or?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  visibility?: StringComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: Array<TenantsBoolExp> | null | undefined;
  _not?: TenantsBoolExp | null | undefined;
  _or?: Array<TenantsBoolExp> | null | undefined;
  allowAutoApproveChangeRequests?: BooleanComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  ownerUser?: UsersBoolExp | null | undefined;
  ownerUserId?: UuidComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenantProductInstallations?: TenantProductInstallationsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: Array<UserGroupsBoolExp> | null | undefined;
  _not?: UserGroupsBoolExp | null | undefined;
  _or?: Array<UserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  users?: UserUserGroupsBoolExp | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_roles". All fields are combined with a logical 'AND'. */
export type UserProductRolesBoolExp = {
  _and?: Array<UserProductRolesBoolExp> | null | undefined;
  _not?: UserProductRolesBoolExp | null | undefined;
  _or?: Array<UserProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "user_segments". All fields are combined with a logical 'AND'. */
export type UserSegmentsBoolExp = {
  _and?: Array<UserSegmentsBoolExp> | null | undefined;
  _not?: UserSegmentsBoolExp | null | undefined;
  _or?: Array<UserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: IntComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type UserTenantsAggregateBoolExp = {
  count?: UserTenantsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: Array<UserTenantsBoolExp> | null | undefined;
  _not?: UserTenantsBoolExp | null | undefined;
  _or?: Array<UserTenantsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  role?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "user_tenants" */
export type UserTenantsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'role'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "user_user_groups". All fields are combined with a logical 'AND'. */
export type UserUserGroupsBoolExp = {
  _and?: Array<UserUserGroupsBoolExp> | null | undefined;
  _not?: UserUserGroupsBoolExp | null | undefined;
  _or?: Array<UserUserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userGroup?: UserGroupsBoolExp | null | undefined;
  userGroupId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_segments". All fields are combined with a logical 'AND'. */
export type UserUserSegmentsBoolExp = {
  _and?: Array<UserUserSegmentsBoolExp> | null | undefined;
  _not?: UserUserSegmentsBoolExp | null | undefined;
  _or?: Array<UserUserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  userSegment?: UserSegmentsBoolExp | null | undefined;
  userSegmentId?: IntComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: Array<UsersBoolExp> | null | undefined;
  _not?: UsersBoolExp | null | undefined;
  _or?: Array<UsersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  displayName?: StringComparisonExp | null | undefined;
  email?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  memo?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  photoUrl?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
  userUserGroups?: UserUserGroupsBoolExp | null | undefined;
  userUserSegments?: UserUserSegmentsBoolExp | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: Array<UserTenantsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserTenantsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type GetEvidenceUsersForSelectFormQueryVariables = Exact<{
  tenantId: string;
  where?: Types.UsersBoolExp | null | undefined;
}>;


export type GetEvidenceUsersForSelectFormQuery = { users: Array<{ __typename: 'Users', id: string, displayName: string | null }> };


export const GetEvidenceUsersForSelectFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvidenceUsersForSelectForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersBoolExp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userTenants"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetEvidenceUsersForSelectFormQuery, GetEvidenceUsersForSelectFormQueryVariables>;